import { registerComponent } from '@gig/magic-common';
import SweepstakesBalanceComponent from './sweepstakes-balance.vue.js';

var SweepstakesBalance = registerComponent(SweepstakesBalanceComponent);

export { SweepstakesBalance };
